"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumDecoder = void 0;
const simple_errors_1 = require("@simonbackx/simple-errors");
class EnumDecoder {
    constructor(e) {
        this.enum = e;
    }
    decode(data) {
        let str;
        try {
            str = data.string;
            if (Object.values(this.enum).includes(str)) {
                return str;
            }
        }
        catch (e) {
            try {
                str = data.number;
                if (Object.values(this.enum).includes(str)) {
                    return str;
                }
            }
            catch (e2) {
                throw new simple_errors_1.SimpleError({
                    code: "invalid_field",
                    message: `Expected a number or string for enum: ` + Object.values(this.enum).join(", "),
                    field: data.currentField,
                });
            }
        }
        throw new simple_errors_1.SimpleError({
            code: "invalid_field",
            message: "Unknown enum value " + str + " expected " + Object.values(this.enum).join(", "),
            field: data.currentField,
        });
    }
}
exports.EnumDecoder = EnumDecoder;
//# sourceMappingURL=EnumDecoder.js.map